import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';
import { environment } from '@environments/environment';
import { PromotionListModel, PromotionListType } from '@components/promotion/promotion.model';

@Injectable({
  providedIn: 'root',
})
export class PromotionService {
  public promotionList: PromotionListModel = new PromotionListModel([]);
  public promotionCount: number;

  constructor(private _ApiService: ApiService) {
    if (environment.isPromotion) {
      this.getPromotionCount();
    }
  }

  getPromotionList() {
    this._ApiService.getPromotionPage().then((promotionItem: PromotionListType) => {
      this.promotionList = new PromotionListModel(promotionItem);
    });
  }

  getPromotionCount() {
    this._ApiService.getPromotionCount().then((promotionCount: { count: number }) => {
      this.promotionCount = promotionCount?.count || 0;
    });
  }
}
